<!--
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
-->
<app-dialog-banner text="Error Monitoring — last {{errors.length}} events" [dialogRef]="dialogRef"></app-dialog-banner>
<mat-dialog-content class="errorLogsContent">
    @if (errors.length === 0) {
        <div class="emptyState">
            <mat-icon>check_circle</mat-icon>
            <span>No errors recorded. All quiet.</span>
        </div>
    } @else {
        <div class="layout" [class.mobile]="isPhone">
            @if (isPhone) {
                <div class="mobileFilters">
                    <mat-form-field appearance="outline" class="mobileSelect" subscriptSizing="dynamic">
                        <mat-label>Date</mat-label>
                        <mat-select [value]="selectedDate" (selectionChange)="selectDate($event.value)">
                            <mat-option [value]="null">All ({{errors.length}})</mat-option>
                            @for (d of mobileDateOptions; track d.date) {
                                <mat-option [value]="d.date">{{formatDateLabel(d.date)}} ({{d.count}})</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="mobileSelect" subscriptSizing="dynamic">
                        <mat-label>Users</mat-label>
                        <mat-select [value]="selectedUser" (selectionChange)="setUser($event.value)">
                            <mat-option [value]="null">All</mat-option>
                            @for (u of topUsers; track u.name) {
                                <mat-option [value]="u.name">{{u.name}} ({{u.count}})</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            } @else {
                <div class="filters">
                    <div class="sectionHeader">By Date</div>
                    <div class="filterRow" [class.selected]="!selectedDate" role="button" tabindex="0"
                        (click)="selectDate(null)" (keyup.enter)="selectDate(null)">
                        <span>All</span>
                        <span class="count">{{errors.length}}</span>
                    </div>
                    @for (d of topDates; track d.date) {
                        <div class="filterRow" [class.selected]="selectedDate === d.date" role="button" tabindex="0"
                            (click)="selectDate(d.date)" (keyup.enter)="selectDate(d.date)">
                            <span>{{formatDateLabel(d.date)}}</span>
                            <span class="count">{{d.count}}</span>
                        </div>
                    }

                    <div class="sectionHeader">Users</div>
                    @for (u of topUsers; track u.name) {
                        <div class="filterRow" [class.selected]="selectedUser === u.name" role="button" tabindex="0"
                            (click)="selectUser(u.name)" (keyup.enter)="selectUser(u.name)">
                            <span>{{u.name}}</span>
                            <span class="count">{{u.count}}</span>
                        </div>
                    }

                    <div class="sectionHeader">Errors</div>
                    @for (m of topMessages; track m.message) {
                        <div class="filterRow" [class.selected]="selectedMessage === m.message" role="button" tabindex="0"
                            [matTooltip]="m.message" (click)="selectMessage(m.message)" (keyup.enter)="selectMessage(m.message)">
                            <span>{{m.label}}</span>
                            <span class="count">{{m.count}}</span>
                        </div>
                    }
                </div>
            }
            <div class="errors">
                @if (isTodayEmpty) {
                    <div class="emptyState">
                        <mat-icon>check_circle</mat-icon>
                        <span>Cool - no errors today</span>
                    </div>
                } @else {
                    <table>
                        <thead>
                            <tr>
                                <th>{{selectedDate ? 'Time' : 'Date'}}</th>
                                <th>Team</th>
                                <th>User</th>
                                <th>Path</th>
                                <th>Related</th>
                                <th>Message</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (e of filteredErrors; track $index) {
                                <tr role="button" tabindex="0" (click)="showDetail(e)" (keyup.enter)="showDetail(e)">
                                    <td class="nowrap mono">{{selectedDate ? timeOf(e) : e.logDate}}</td>
                                    <td class="mono">{{e.teamId}}</td>
                                    <td>{{e.userName}}</td>
                                    <td class="mono">{{e.pathName}}</td>
                                    <td>{{e.relatedName}}</td>
                                    <td class="message" [matTooltip]="e.message">{{e.message}}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                }
            </div>
        </div>
    }
</mat-dialog-content>
